(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/set-iframe-height.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/set-iframe-height.js');
"use strict";


const setIframeHeight = iframe => {
  const pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1.0;
  let height = window.innerHeight;
  const topContent = document.querySelector('.js-fixed-top-content');
  if (topContent) {
    height -= topContent.offsetHeight / pixelRatio;
  }
  const sportsbookItems = document.querySelector('.js-sportsbook-items');
  if (sportsbookItems) {
    height -= sportsbookItems.offsetHeight / pixelRatio;
  }
  const selfserviceMiniCart = document.querySelector('.js-selfservice-mini-cart');
  if (selfserviceMiniCart) {
    height -= selfserviceMiniCart.offsetHeight / pixelRatio;
  }
  const sportbooksSelfserviceBetslip = document.querySelector('.js-sportsbook-betslip.sportsbook-betslip--is-open');
  if (sportbooksSelfserviceBetslip ) {
    height -= sportbooksSelfserviceBetslip.offsetHeight / pixelRatio;
  }
  height = Math.round(height);
  iframe.style.height = "".concat(height, "px");
};
setGlobal('svs.sportsbook.sbtech_api_impl.utils.setIframeHeight', setIframeHeight);

 })(window);